import axios from 'axios';
import { useCallback, useMemo } from 'react';
import { colors } from '../../../../../../../colors';
import AssetIcon from '../../../../../../../components/AssetIcon';
import { SubscriptionState } from '../../../../../types';
import './index.css';

import ServicePaths from '../../../../../../../bridge/utils/ServicePaths';

interface Props {
  state: SubscriptionState;
  handleMove: (state: SubscriptionState) => void;
}

const StateListItem = (props: Props) => {
  const { state, handleMove } = props;
  const {
    baseAsset,
    quoteAsset,
    clusterId,
    isActive,
    subscriptionId,
    isAutomatedOrder,
    isNotificationEnabled,
  } = state;

  const activeStateColor = useCallback(
    (state: boolean) => (state ? colors.green : colors.red),
    [],
  );

  const buttonColor = useMemo(
    () => (isActive ? colors.red : colors.green),
    [isActive],
  );

  const buttonText = useMemo(
    () => (isActive ? 'De-activate' : 'Activate'),
    [isActive],
  );

  const handleClick = useCallback(async () => {
    const { data } = await axios({
      method: 'POST',
      url: ServicePaths.CONTROL.EditSubscription,
      params: {
        subscriptionId,
        subscription: JSON.stringify({ isActive: !isActive }),
      },
    });

    if (!data?.success) {
      return;
    }

    handleMove(state);
  }, [handleMove, isActive, state, subscriptionId]);

  return (
    <div className="states-item-root">
      <div className="states-item-asset-icon">
        <AssetIcon baseAsset={state.baseAsset} width={40} height={40} />
      </div>
      <span className="bi-asset-container states-item-margin-fix">
        <h4 className="bi-asset-text-label">BaseAsset:</h4>
        <h4 className="bi-asset-text">{baseAsset}</h4>
      </span>
      <span className="bi-asset-container states-item-margin-fix">
        <h4 className="bi-asset-text-label">QuoteAsset:</h4>
        <h4 className="bi-asset-text">{quoteAsset}</h4>
      </span>
      <span className="bi-asset-container states-item-margin-fix">
        <h4 className="bi-asset-text-label">Cluster Id:</h4>
        <h4 className="bi-asset-text">{clusterId}</h4>
      </span>
      <span className="bi-asset-container states-item-margin-fix">
        <h4 className="bi-asset-text-label">Automated Bot:</h4>
        <h4
          className="bi-asset-text"
          style={{ color: activeStateColor(isAutomatedOrder) }}
        >
          {isAutomatedOrder ? 'On' : 'Off'}
        </h4>
      </span>
      <span className="bi-asset-container states-item-margin-fix">
        <h4 className="bi-asset-text-label">Notifications enabled:</h4>
        <h4
          className="bi-asset-text"
          style={{ color: activeStateColor(isNotificationEnabled) }}
        >
          {isNotificationEnabled ? 'On' : 'Off'}
        </h4>
      </span>
      <div
        className="states-item-button"
        style={{
          backgroundColor: buttonColor,
          cursor: 'pointer',
        }}
        onClick={handleClick}
      >
        <p
          className="states-item-button-text"
          style={{
            color: colors.white,
          }}
        >
          {buttonText}
        </p>
      </div>
    </div>
  );
};

export default StateListItem;
